import { scroller } from 'react-scroll';

const scroll = section => {
  const target = section || null;
  target && scroller.scrollTo(target, {
    offset: -200,
    duration: 1500,
    smooth: 'easeInOutQuint',
  });
};

const scrollIfHashMatch = (hash, delay = 1000) => {
  if (window.location.hash === `#${hash}`) {
    if (delay) {
      setTimeout(() => scroll(hash), delay);
    } else {
      scroll(hash);
    }
  }
};

export {
  scroll,
  scrollIfHashMatch,
};
